"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = anonymousTrack;
var _uuid = require("uuid");
var _common = require("./common");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function anonymousTrack(config, event) {
  var _user$session;
  var amplitudeToken = config.amplitudeToken,
    user = config.user;
  var data = event.data;
  var amplitudeEvent = data.amplitudeEvent,
    amplitudeUserProperties = data.amplitudeUserProperties;

  // Bail if no Amplitude token, admin impersonation, or no amplitude event in data
  if (!amplitudeToken || user !== null && user !== void 0 && (_user$session = user.session) !== null && _user$session !== void 0 && _user$session.isAdminImpersonation || !amplitudeEvent) {
    return;
  }
  var userProperties = amplitudeUserProperties ? _objectSpread({}, amplitudeUserProperties) : {};
  var eventData = (0, _common.prepareEventProperties)(amplitudeEvent, data);
  var userId = !user.id || user.id === '1' ? '' : user.id;

  // if the user is logged out, mark this as an anonymized event
  if (!userId) {
    userProperties.isAnonymized = true;
  }

  // Generate unique uuid for device ID
  var deviceId = (0, _uuid.v4)();

  // Send the event via beacon to avoid any built in cookie Action
  try {
    navigator.sendBeacon('https://api2.amplitude.com/2/httpapi', JSON.stringify({
      api_key: amplitudeToken,
      events: [{
        device_id: deviceId,
        user_id: userId,
        event_type: amplitudeEvent,
        event_properties: eventData,
        user_properties: {
          $set: userProperties
        },
        ip_address: '$remote',
        user_agent: navigator.userAgent,
        language: navigator.language,
        platform: 'Web'
      }]
    }));
  } catch (error) {
    console.error(error);
  }
}
module.exports = exports.default;
//# sourceMappingURL=anonymous.js.map